import axios from 'axios'
import JSONbig from 'json-bigint'
// import { Message } from 'element-ui'
import router from '@/router'
import {
    message
} from '@/utils/resetMessage';

// create an axios instance
const service = axios.create({
    transformResponse: [function(data) {
        // Do whatever you want to transform the data
        // console.log(JSON.parse(data), JSONbig.parse(data))
        // return JSON.parse(data)
        return JSONbig.parse(data)
    }],
    // proxy: {

    // },
    crossDomain: true,
    baseURL: process.env.API_ROOT, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        // console.log(config)
        config.headers['Accept'] = 'application/json'
        config.headers['Content-Type'] = 'application/json'
            // if (config.method === 'post'||config.method === 'put') { 
            //   config.data = qs.stringify({
            //     ...config.data
            //   })
            // }

        // config.headers['Authorization'] = getToken()
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        // console.log(response);
        return response;
    },
    error => {
        //表单422特殊处理
        // console.log(error.response.config)
        if (error.response.status == 422) {
            var urlStr = error.response.config.url.split('?')[0].split('/')
            if (urlStr[4] == "verify-code" || urlStr[3] == "verify-code" || urlStr[1] == 'bind-mobile' || urlStr[2] == 'mobile-exist' || urlStr[2] == 'register' || urlStr[2] == 'login' || urlStr[2] == 'mobile-login' || urlStr[2] == 'name') {
                var str = ''
                if (error.response.data.errors) {
                    for (const key in error.response.data.errors) {
                        if (error.response.data.errors.hasOwnProperty(key)) {
                            const element = error.response.data.errors[key];
                            str += element[0]
                        }
                    }
                } else {
                    str += error.response.data.message
                }
                str = str.replace(/\s*/g, "");
                //验证码登录手机号不存在特殊处理 和 绑定手机号已存在特殊处理
                if (str.indexOf('手机号不存在') != -1) {
                    str = '手机号不存在'
                }
                if (str.indexOf('手机号已经存在') != -1) {
                    str = '手机号已存在，请直接用手机号登录'
                }
                return Promise.reject(str)
            }
        }
        if (error.response) {
            switch (error.response.status) {
                case 401:
                case 403:
                    if (window.location.pathname != "/login" && window.location.pathname != "/mlogin") {
                        router.push({ name: "login" })
                    }
                    break;
                case 422:
                    var str = ''
                    if (error.response.data.errors) {
                        for (const key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                const element = error.response.data.errors[key];
                                str += element[0]
                            }
                        }
                    } else {
                        str += error.response.data.message
                    }

                    // if(str !== '验证码错误'){
                    //     message({
                    //         message: str,
                    //         type: 'error',
                    //         duration: 2000
                    //     })
                    // }
                    if(str === "图形验证码错误" || str === "手机号不存在" || str === "手机号格式不正确" || str === "邮箱不存在"){

                    }else{
                        if(str !== '验证码错误'){
                            message({
                                message: str,
                                type: 'error',
                                duration: 2000
                            })
                        }
                    }
                    // console.log('erro-response2',str)
                    break;
                case 409:
                    var str = ''
                    if (error.response.data.message) {
                        str += error.response.data.message
                    }
                    message({
                        message: str,
                        type: 'error',
                        duration: 2000
                    })
                    break;
                case 429:
                    var str = ''
                    if (error.response.data.message) {
                        str += error.response.data.message
                    }
                    message({
                        message: str,
                        type: 'error',
                        duration: 2000,
                        onClose: function() {}
                    })
                    break;
                default:
                    var str = ''
                    if (error.response.data.message) {
                        str += error.response.data.message
                    }
                    message({
                        message: str,
                        type: 'error',
                        duration: 2000,
                        onClose: function() {
                            if (window.location.pathname != "/login" && window.location.pathname != "/mlogin") {
                                // alert(window.location)
                                // alert(window.location.pathname)
                                router.push({ name: "login" })
                            }
                        }
                    })
                    break;
            }
        }
        return Promise.reject(error.response)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js